import React from 'react';
import { Box, Chip } from '@mui/material';
import { JournalPostStatus, SalaryPaymentStatus } from '../../interfaces/salaryPayment';

interface Props {
    status: SalaryPaymentStatus;
    journalPostStatus?: JournalPostStatus;
}

type ChipColor = 'success' | 'warning' | 'error' | 'default';

const paymentColor = (s: SalaryPaymentStatus): ChipColor => {
    switch (s) {
        case 'COMPLETED': return 'success';
        case 'PENDING': return 'warning';
        case 'REVERSED': return 'default';
        default: return 'default';
    }
};

const journalColor = (s: JournalPostStatus): ChipColor => {
    switch (s) {
        case 'POSTED': return 'success';
        case 'PENDING': return 'warning';
        case 'FAILED': return 'error';
        case 'SKIPPED': return 'default';
        default: return 'default';
    }
};

const PaymentStatusChip: React.FC<Props> = ({ status, journalPostStatus }) => {
    return (
        <Box sx={{ display: 'inline-flex', gap: 0.5, flexWrap: 'wrap' }}>
            <Chip size="small" label={status} color={paymentColor(status)} />
            {journalPostStatus && (
                <Chip
                    size="small"
                    variant="outlined"
                    label={`Journal: ${journalPostStatus}`}
                    color={journalColor(journalPostStatus)}
                />
            )}
        </Box>
    );
};

export default PaymentStatusChip;
